<script setup lang="ts">
// @ts-ignore "no types"
import { AccordionList, AccordionItem } from 'vue3-rich-accordion'
const { locale } = useI18n()

const props = defineProps<{
	pageSection: ICMSLocationContent
}>()

const sectionContent = ref<ICMSLocationContentTranslations>(
	props.pageSection?.translations.find((translation) => translation.language === locale.value)?.content,
)

const col1 = computed(() => {
	return sectionContent.value?.filter((_, idx) => idx % 2 === 0)
})

const col2 = computed(() => {
	return sectionContent.value?.filter((_, idx) => idx % 2 !== 0)
})

const isAnyContent = computed(() => {
	return sectionContent.value?.some((item) => item.question !== '' && item.answer !== '')
})
</script>

<template>
	<section v-if="isAnyContent" class="questions">
		<h2 data-aos="fade-up" class="questions__title">{{ $t(`modules.contact_page_modules.contact_page_questions.qa`) }}</h2>
		<div data-aos="fade-up" class="questions__container">
			<AccordionList :open-multiple-items="true">
				<AccordionItem v-for="(item, idx) in col1" :key="idx" class="questions__item" :defaultOpened="false">
					<template #summary>
						<div class="questions__item-summary">
							<h3>{{ item.question }}</h3>
						</div>
					</template>
					<template #icon><GlobalIcon name="arrow-up" :width="20" :height="20" /></template>
					<p class="questions__item-description">
						{{ item.answer }}
					</p>
				</AccordionItem>
			</AccordionList>
			<AccordionList :open-multiple-items="true">
				<AccordionItem v-for="(item, idx) in col2" :key="idx" class="questions__item" :defaultOpened="false">
					<template #summary>
						<div class="questions__item-summary">
							<h3>{{ item.question }}</h3>
						</div>
					</template>
					<template #icon><GlobalIcon name="arrow-up" :width="20" :height="20" /></template>
					<p class="questions__item-description">
						{{ item.answer }}
					</p>
				</AccordionItem>
			</AccordionList>
		</div>
	</section>
</template>

<style scoped lang="scss">
@import './ContactPageQuestions.scss';
</style>
